import { useContext } from "react";
import { PatientOrdersModalContext } from "./PatientOrdersModalProvider";

export const usePatientOrdersModal = () => {
  return useContext(PatientOrdersModalContext);
};
